module.exports = __webpack_public_path__ + "static/media/tc.47c82761.svg";